import { render, staticRenderFns } from "./ResetEmailSendSuccessPage.vue?vue&type=template&id=74bc21d6&"
import script from "./ResetEmailSendSuccessPage.vue?vue&type=script&lang=js&"
export * from "./ResetEmailSendSuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports